import { connect } from 'react-redux';
import { ReactNode } from 'react';

import { FeatureFlagsProvider, Props } from '@investown/fe/common-utils';

import { RootState } from 'appRedux/store/rootReducer';
import * as authSelectors from 'appRedux/auth/selectors';

type StateProps = Pick<Props, 'isUserSignedIn' | 'userInfo'>;
type OwnProps = Omit<Props, 'isUserSignedIn' | 'userInfo'> & { children: ReactNode };

const connector = connect<StateProps, void, OwnProps, RootState>((state) => ({
  isUserSignedIn: authSelectors.isUserSignedIn(state.auth),
  userInfo: authSelectors.getBasicUserInfo(state.auth),
}));

export default connector(FeatureFlagsProvider);
